<template>
    <div class="row">
        <div class="col-lg-6 order-2 order-lg-0">
            <b-overlay :show="loading" opacity="0.2">
                <form :name="form.name" :method="form.method" ref="form" :action="form.action" autocomplete="off">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <label class="form-label">İsim Soyisim</label>
                            <input v-card.holder class="form-control" type="text" v-model="fullName" placeholder="İsim Soyisim" />
                            <input type="hidden" :value="fullName" :name="form.holderFullName" />
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Kart Numarası</label>
                            <input v-card.card-number class="form-control" v-mask="'#### #### #### ####'" type="text"  v-model="cardNumber"  placeholder="Kart Numarası"/>
                            <input type="hidden" :name="form.cardNumber" :value="cardNumber"  />
                        </div>
                        <div class="col-6 mb-1">
                            <label class="form-label">Ay</label>
                            <select v-card.expire class="form-control" v-model="expireMonth">
                                <option :value="null">Ay</option>
                                <option v-for="m in months" :key="m.value" :value="m.text">{{ m.text }}</option>
                            </select>
                            <input type="hidden" :value="expireMonth" :name="form.expireMonth"/>
                        </div>
                        <div class="col-6 mb-1">
                            <label class="form-label">Yıl</label>
                            <select v-card.expire class="form-control" v-model="expireYear">
                                <option :value="null">Yıl</option>
                                <option v-for="y in years" :key="y.value" :value="y.value">{{ y.text }}</option>
                            </select>
                            <input type="hidden" :name="form.expireYear" :value="expireYear"/>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">CVC</label>
                            <input v-card.cvc class="form-control" type="text" v-model="cvc"  v-mask="'####'" placeholder="CVC"/>
                            <input type="hidden" :name="form.cvc" :value="cvc"/>
                        </div>
                        <!-- <div class="col-12 mb-1" v-if="canInstallment">
                            <b-form-radio-group v-model="installment" :options="c_installments">
                            </b-form-radio-group>
                        </div> -->
                        <div class="col-12">
                            <div class="bg-light text-right rounded p-1">
                                <div class="d-flex align-items-center mb-1">
                                    <span class="text-muted h4 mb-0 mr-1 text-nowrap">Ödenecek Tutar: </span>
                                    <v-currency-input input-class="text-right currency-font-size" :value="amount" v-on:updateValue="value => $emit('update:amount',value)"></v-currency-input>
                                    <span class="h4 mb-0 ml-1">₺</span>
                                </div>
                                <ul class="list-group mb-1" v-if="(canInstallment && (c_installments || []).length)">
                                    <li v-for="(ins,i) in c_installments" class="list-group-item px-75 py-50" :key="i">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <b-form-radio v-model="installment" :value="ins.value" >{{ ins.text }}&nbsp;<span v-if="ins.com > 1" class="text-muted">({{ ins.com }}%)</span></b-form-radio>
                                            {{ ins.amount }}
                                        </div>
                                    </li>
                                </ul>
                                <button type="button" class="btn btn-success w-100" v-on:click="pay">Öde</button>
                            </div>
                        </div>
                    </div>
                    <input type="hidden" :value="amount" name="amount"/>
                    <input type="hidden" :value="orderId" name="oid" />
                    <input type="hidden" :value="rnd" name="rnd" />
                    <input type="hidden" :value="hash" name="hash" />
                    <input type="hidden" :value="installment" name="taksit" />
                    <input type="hidden" :value="code" name="paymentCode"/>
                    <input type="hidden" value="5" name="bankvalue"/>
                    <input type="hidden" value="1" name="refreshtime" />
                    <input type="hidden" name="hashAlgorithm" value="ver3" />

            <input type="hidden" name="callbackUrl" value="">

            <!-- <input type="hidden" name="storeKey" :value="const_storeKey"> -->
            <input type="hidden" name="clientid" :value="const_clientid">
            <input type="hidden" name="TranType" :value="const_TranType">
            <input type="hidden" name="okurl" :value="const_okurl">
            <input type="hidden" name="failUrl" :value="const_failurl">
            <input type="hidden" name="storetype" :value="const_storeType">
            <input type="hidden" name="lang" :value="const_lang">
            <input type="hidden" name="currency" :value="const_currency">

                    <!-- <input type="hidden" v-for="param in parameters" :key="param.Id" :value="param.Value" :name="param.Key" /> -->
                </form>
            </b-overlay>
        </div>
        <div class="col-lg-6 order-0 order-lg-2">
            <div class="d-flex justify-content-center h-100 align-items-center p-2">
                <v-credit-card  ref="card"
                                :card-number="cardNumber" 
                                :expire-month="expireMonth" 
                                :expire-year="expireYear" 
                                :cvc="cvc" 
                                :holder="fullName"></v-credit-card>
            </div>
        </div>
    </div>
</template>

<script>
import { BOverlay,BFormRadio,BFormRadioGroup } from 'bootstrap-vue'
import { SystemParameterApi } from '@/api/system-parameter'
import { SystemDataApi } from '@/api/system-data'
import { PaymentApi } from '@/api/payment'
import randomatic from 'randomatic'
import VCreditCard from '@/components/v-credit-card/VCreditCard.vue'
import { cardDirective } from '@/components/v-credit-card/index'
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import moment from 'moment'
import Additional from '@/utilities/additional'

export default {
    components:{
        BOverlay,
        BFormRadio,
        BFormRadioGroup,
        VCreditCard,
        VCurrencyInput
    },
    props:{
        bankValue:Number,
        code:String,
        amount:Number,
        amountStr:String,
        canInstallment:Boolean,
        installments:{
            type:Array,
            default:()=>[]
        }
    },
    directives:{
        "card":cardDirective
    },
    data() {
        return {
            loading:false,
            parameters:[],
            fullName:null,
            cardNumber:null,
            expireMonth:null,
            expireYear:null,
            cvc:null,
            hash:null,
            months:[],
            years:[],
            installment:"",

            const_storeKey:"",
            const_clientid: "190712325",
            const_TranType:"Auth",
            const_okurl:"https://localhost:7186/api/payment/create",
            const_failurl:"https://localhost:7186/api/payment/create",
            const_storeType:"3d_pay_hosting",
            const_lang:"tr",
            const_currency:"949",

            orderId:randomatic("0",20),
            rnd:randomatic("Aa0",20),
            form:{
                name:'ziraat_bank_pay_form',
                method:'post',
                action:'https://sanalpos2.ziraatbank.com.tr/fim/est3Dgate',
                holderFullName:'name',
                cardNumber:'pan',
                expireMonth:'Ecom_Payment_Card_ExpDate_Month',
                expireYear:'Ecom_Payment_Card_ExpDate_Year',
                // cvc:'cv2'
                cvc:'cvc'
            },
        }
    },
    mounted(){
        this.getParameters()
        this.months = Array.from({ length: 12 }, (_, i) => i).map(i=>{
            return {
                text: i+1 < 10 ? `0${i+1}` : `${i+1}`,
                value:i+1
            }
        })
        this.years = Array.from({ length: 50 }, (_, i) => i).map(i=>{
            let year = moment().add(i,'years').format('YYYY')
            return {
                text: year,
                value: year.slice(-2)
            }
        })
    },
    methods:{
        getParameters(){
            this.loading = true
            SystemParameterApi.Bank(this.bankValue).then(res=>{
                if(res.data.Success){
                    this.parameters = res.data.Data
                    // set
                    this.const_storeKey = this.parameters.find(p=>p.Key == "storekey")?.Value || "";
                    this.const_clientid =  this.parameters.find(p=>p.Key == "clientid")?.Value || this.const_clientid;
                    this.const_TranType = this.parameters.find(p=>p.Key == "islemtipi")?.Value || this.const_TranType;
                    this.const_okurl = this.parameters.find(p=>p.Key == "okUrl")?.Value || this.const_okurl;
                    this.const_failurl = this.parameters.find(p=>p.Key == "failUrl")?.Value || this.const_okurl;
                    this.const_storeType = this.parameters.find(p=>p.Key == "storetype")?.Value || this.const_storeType;
                    this.const_lang = this.parameters.find(p=>p.Key == "lang")?.Value || this.const_lang
                    this.const_currency = this.parameters.find(p=>p.Key == "currency")?.Value || this.const_currency
                    this.loading = false
                } else this.$result(res)
            }).catch(err=>{
                this.$result(null,err)
            })
        },
        pay(e){
            e.preventDefault()
            this.loading = true
            try {
                const CLIENT_ID = this.const_clientid
            const OK_URL = this.const_okurl
            const FAIL_URL = this.const_failurl
            const TRANSACTION = this.const_TranType
            const STORE_KEY = this.const_storeKey


                let HASH_DATA = [
                    this.amount,  //amount
                    this.bankValue, //bankValue
                    // this.const_okurl, //callbackurl
                    '', //callbackurl
                    CLIENT_ID, //clientid
                    this.const_currency, //currency
                    this.cvc, //cv2
                    this.expireMonth, //Ecom_Payment_Card_ExpDate_Month
                    this.expireYear,  //Ecom_Payment_Card_ExpDate_Year
                    FAIL_URL, //failurl
                    'ver3', //hashalgorithm 
                    this.const_lang, //lang
                    this.fullName, //name
                    this.orderId, //Custom OrderId  - oid
                    OK_URL, //okurl
                    this.cardNumber, //pan
                    this.code,  //paymentCode
                    '1', //refreshtime
                    this.rnd, //rnd
                    this.const_storeType, //storetype
                    this.installment, //taksit
                    TRANSACTION, //trantype,
                    STORE_KEY
                    // this.hash,

                    // ,
                    
                ].join('|')
                PaymentApi.PreparePayment({
                    Amount:this.amount,
                    OrderId:this.orderId,
                    CardNumber:this.cardNumber,
                    FullName:this.fullName,
                    GroupCode:this.code,
                    Bank:this.bankValue,
                    Installment:this.installment
                }).then(res => {
                    SystemDataApi.CalculateSHA512({PlainText:HASH_DATA}).then(res=>{
                        this.hash = res.data
        
           
        const allowedFields = ['name', 'pan', 'Ecom_Payment_Card_ExpDate_Month', 'Ecom_Payment_Card_ExpDate_Year', 'cvc', 'bankvalue', 'amount',
        'orderId', 'rnd', 'hash', 'taksit', 'paymentCode', 'refreshtime', 'hashAlgorithm', 'callbackUrl', 'storeKey', 'clientid', 'TranType', 
        'okurl', 'failUrl', 'storetype', 'lang', 'currency', 'oid'
        ]; 
        const form = this.$refs.form;
        // const formData = new FormData(form); // Formun tüm verilerini al
        
        // const filteredFormData = new FormData();
        const removedElements = [];

            for (let element of [...form.elements]) { 
            if (!allowedFields.includes(element.name)) {
                removedElements.push(element); 
                element.parentNode.removeChild(element); 
            }
        }

        this.$nextTick(()=>{
            this.$refs.form.submit()
        })
                    })
                }).catch(err=>{
                    this.loading = false
                    console.log(err)
                })
                

            } catch (error) {
                console.log(error)
                this.loading = false
            }
        }
    },
    computed:{
        c_installments(){
            const amount = (t) => {
                if(this.amount){
                    let cr = t.CommissionRate || 1
                    let ins = t.Value ? Number(t.Value) : null
                    if(ins){
                        let newAmount = cr > 1 ? this.amount + (this.amount * (cr / 100)) : this.amount
                        let insAmount = newAmount / ins
                        return `${ins} x ${Additional.ConvertMoney(insAmount)} ₺`
                    }else return Additional.ConvertMoney(this.amount) + " ₺"
                }else return null
            }


            return this.installments.map(t=> {
                return {
                    value:t.Value,
                    text:t.Text,
                    com:t.CommissionRate || 1,
                    amount:amount(t)
                }
            })
        }
    }
}
</script>

<style>

</style>